<template>
  <a :class="{ 'i-state-disabled': !enabled }" href="#">
    <i-icon :icon="icon" />
    <span class="pl1">
      <slot>-</slot>
    </span>
  </a>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'i-action-link',
  props: {
    enabled: {
      type: Boolean,
    },
    icon: {
      type: String,
    },
  },
});
</script>

<style scoped lang="scss">
.i-state-disabled {
  color: #999;
  background-color: #fff;
  pointer-events: none;
  cursor: no-drop !important;
}
</style>
